(() => {
	if (!customElements.get("echo-slider")) {
		class echoSlider extends HTMLElement {
			constructor() {
				super();
			}

			init() {
				const slider = this.querySelector(".swiper");

				// FIX: Parse attributes as numbers and provide fallback defaults
				const desktopSlidesPerView = parseFloat(this.getAttribute("data-slide-per-row")) || 3;
				const spaceBetween = parseFloat(this.getAttribute("data-space-between")) || 10;
				const showDots = this.getAttribute("data-show-dots");
				const showArrows = this.getAttribute("data-show-arrows");
				
				const nextArrow = this.querySelector('.swiper-button-next');
				const prevArrow = this.querySelector('.swiper-button-prev');

				const mobileSlidesPerView = parseFloat(this.getAttribute(
					"data-mobile-slide-per-row"
				)) || 1; // Default to 1 slide on mobile (most common)

				const swiperOptions = {
					// Use the parsed numeric value for mobile
					slidesPerView: mobileSlidesPerView,
					spaceBetween: spaceBetween,
					loop: false,
					breakpoints: {
						// Use the parsed numeric value for the 640px breakpoint
						640: {
							slidesPerView: mobileSlidesPerView, // Using mobile value for smaller tablet/desktop
							spaceBetween: spaceBetween,
						},
						// Use the parsed numeric value for the 768px breakpoint
						768: {
							slidesPerView: desktopSlidesPerView,
							spaceBetween: spaceBetween,
						},
					},
				};

				// Check if data-show-dots is set to 'yes', if so, include pagination options
				if (showDots === "yes") {
					swiperOptions.pagination = {
						el: ".swiper-pagination",
						clickable: true,
					};
				}

				// Check if data-show-dots is set to 'yes', if so, include pagination options
				if (showArrows === "yes") {
					swiperOptions.navigation = {
						nextEl: nextArrow,
						prevEl: prevArrow,
					};
				}

				const swiper = new Swiper(slider, swiperOptions);
			}

			connectedCallback() {
				this.init();
			}
		}
		customElements.define("echo-slider", echoSlider);
	}
})();